import {
  AreaChart as RechartsAreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from 'recharts';
import type { MultiSeriesDataPoint } from '@/types/metrics.types';

interface AreaChartProps {
  data: MultiSeriesDataPoint[];
  areas: { key: string; color: string; label: string }[];
  height?: number;
  xKey?: string;
}

export function AreaChart({ data, areas, height = 300, xKey = 'date' }: AreaChartProps) {
  return (
    <ResponsiveContainer width="100%" height={height}>
      <RechartsAreaChart data={data} margin={{ top: 5, right: 20, left: 0, bottom: 5 }}>
        <defs>
          {areas.map((area) => (
            <linearGradient key={area.key} id={`gradient-${area.key}`} x1="0" y1="0" x2="0" y2="1">
              <stop offset="5%" stopColor={area.color} stopOpacity={0.3} />
              <stop offset="95%" stopColor={area.color} stopOpacity={0} />
            </linearGradient>
          ))}
        </defs>
        <CartesianGrid strokeDasharray="3 3" stroke="#334155" />
        <XAxis dataKey={xKey} stroke="#94a3b8" tick={{ fontSize: 11, fill: '#94a3b8' }} />
        <YAxis stroke="#94a3b8" tick={{ fontSize: 11, fill: '#94a3b8' }} />
        <Tooltip
          contentStyle={{ backgroundColor: '#1e293b', border: '1px solid #334155', borderRadius: '12px', boxShadow: '0 4px 16px rgba(0,0,0,0.35)' }}
          labelStyle={{ color: '#e2e8f0', fontWeight: 600 }}
          itemStyle={{ color: '#cbd5e1' }}
        />
        {areas.map((area) => (
          <Area
            key={area.key}
            type="monotone"
            dataKey={area.key}
            name={area.label}
            stroke={area.color}
            strokeWidth={2}
            fill={`url(#gradient-${area.key})`}
          />
        ))}
      </RechartsAreaChart>
    </ResponsiveContainer>
  );
}
